module.exports = __webpack_public_path__ + "static/img/mangguo.e6588c50.png";